import { render, staticRenderFns } from "./customersMobile.vue?vue&type=template&id=23c0ecbb&scoped=true&"
import script from "./customersMobile.vue?vue&type=script&lang=js&"
export * from "./customersMobile.vue?vue&type=script&lang=js&"
import style0 from "./customersMobile.vue?vue&type=style&index=0&id=23c0ecbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0ecbb",
  null
  
)

export default component.exports